// extracted by mini-css-extract-plugin
export default {"root":"systemToast_root__sbv+g","icon":"systemToast_icon__a14Gw","title":"systemToast_title__v+wKV","subtitle":"systemToast_subtitle__OWk0j"};